import React, { useContext, useEffect, useState, useRef } from "react";
import {
    getRawMaterials,
    deleteRawMaterials,
    updateRawMaterials,
    createRawMaterials,
    getUnits,
    getRawMaterialBatches,
    adjustRawMaterialStock,
    get_rawtransaction
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { isReadonlyRoute, NaviGate, getStoredEntriesPerPage, setStoredEntriesPerPage } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { useLocation, useNavigate } from "react-router-dom"
import { EditRawMaterials } from "./rform";

const RawMaterials = () => {
    const { showLoader, hideLoader, shopItem, warehouse, UserItem } = useContext(WarehouseContext);
    const { pathname, search } = useLocation();
    const navigate = useNavigate();
    const readonly = isReadonlyRoute(pathname);

    const isPkgRoute = pathname === "/packaging_materials" || search.includes("type=1") || search.includes("tab=pkg") || search.includes("pkg");
    const currentStorageKey = isPkgRoute ? "packaging_materials" : "raw_materials";

    const [rawmaterials, setRawmaterials] = useState([]);
    const [selectedRaw, setSelectedRaw] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [addOrEdit, setAddOrEdit] = useState(true);
    const [activeTab, setActiveTab] = useState(isPkgRoute ? "1" : "raw");

    const [deleteID, setDeleteID] = useState("");
    const [deletemodel, showDeletemodel] = useState(false);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(() => getStoredEntriesPerPage(currentStorageKey, 10));
    const rolesPerPage = 10;
    const [unitsList, setUnitsList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const isMounted = useRef(false);

    const [showAdjustModal, setShowAdjustModal] = useState(false);
    const [adjustRawMaterial, setAdjustRawMaterial] = useState(null);
    const [adjustFormData, setAdjustFormData] = useState({
        date: new Date().toISOString().split("T")[0],
        adjustment_type: "add",
        qty: "",
        unit_id: "",
        price_unit: "",
        total_price: "",
        remarks: "",
    });

    // Report Modal State
    const [showReportModal, setShowReportModal] = useState(false);
    const [reportRawMaterial, setReportRawMaterial] = useState(null);
    const [allReportTransactions, setAllReportTransactions] = useState([]);
    const [reportFilter, setReportFilter] = useState(""); // "" = All, "1" = Added, "0" = Taken
    const [reportLoading, setReportLoading] = useState(false);
    const reportPrintRef = useRef(null);

    const openReportModal = async (raw) => {
        setReportRawMaterial(raw);
        setReportFilter("");
        setShowReportModal(true);
        fetchReportTransactions(raw.id);
    };

    const fetchReportTransactions = async (raw_id) => {
        setReportLoading(true);
        try {
            const response = await get_rawtransaction(1, 10000, "", "", "", raw_id);
            if (response.data && response.data.data) {
                setAllReportTransactions(response.data.data);
            } else {
                setAllReportTransactions([]);
            }
        } catch (error) {
            console.error("Error fetching report transactions:", error);
            toast.error("Failed to load transaction report");
        } finally {
            setReportLoading(false);
        }
    };

    const handlePrintReport = () => {
        const printContent = reportPrintRef.current;
        if (!printContent) return;
        const printWindow = window.open("", "", "width=900,height=650");
        printWindow.document.write(`
            <html>
                <head>
                    <title>Raw Material Date-Wise Report - ${reportRawMaterial?.title || ""}</title>
                    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
                    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css">
                    <style>
                        body { font-family: 'Poppins', sans-serif; padding: 25px; color: #222; }
                        .table { font-size: 12px; border-color: #dee2e6; }
                        .badge { font-size: 11px; }
                        h4 { font-weight: 700; color: #111; }
                        .print-header { border-bottom: 2px solid #0d6efd; padding-bottom: 12px; margin-bottom: 20px; }
                    </style>
                </head>
                <body>
                    <div class="print-header d-flex justify-content-between align-items-center">
                        <div>
                            <h4 class="m-0">ZTR ERP - Raw Material Date-Wise Report</h4>
                            <p class="text-muted m-0" style="font-size: 13px;">
                                Material: <strong>${reportRawMaterial?.title || ""}</strong> | Code: ${reportRawMaterial?.product_code || "N/A"} | Type: ${reportRawMaterial?.type == "2" ? "Liquid" : reportRawMaterial?.type == "1" ? "Packaging Material" : "Spices"}
                            </p>
                        </div>
                        <div class="text-end">
                            <span class="badge bg-primary fs-6">Available Stock: ${parseFloat(reportRawMaterial?.remaining_stock || 0).toFixed(2)} ${reportRawMaterial?.type == "2" ? "li" : getUnitName(reportRawMaterial?.unit_id)}</span>
                            <div class="text-muted mt-1" style="font-size: 11px;">Generated on: ${new Date().toLocaleString("en-GB")}</div>
                        </div>
                    </div>
                    ${printContent.innerHTML}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 400);
    };

    const openAdjustModal = async (raw) => {
        setAdjustRawMaterial(raw);
        
        // Find default unit based on raw material type
        let defaultUnit = "";
        if (raw.type === "2") {
            const found = unitsList.find(u => {
                const title = (u.title || "").toLowerCase();
                return title === "li" || title === "litre" || title === "litres" || title === "liter" || title === "liters";
            });
            defaultUnit = found ? found.id : "li";
        } else if (raw.type === "1") {
            const found = unitsList.find(u => u.title?.toLowerCase() === "pcs");
            defaultUnit = found ? found.id : "pcs";
        } else {
            defaultUnit = raw.unit_id || "";
            if (!defaultUnit) {
                const found = unitsList.find(u => {
                    const title = (u.title || "").toLowerCase();
                    return title === "kg" || title === "kilogram" || title === "kilograms";
                });
                defaultUnit = found ? found.id : "1";
            }
        }

        let defaultPrice = "0.00";
        showLoader();
        try {
            const response = await getRawMaterialBatches(raw.id, shopItem?.id);
            if (response.data && response.data.data && response.data.data.length > 0) {
                const latestBatch = response.data.data[0];
                if (latestBatch && latestBatch.price_unit) {
                    defaultPrice = parseFloat(latestBatch.price_unit).toFixed(2);
                }
            }
        } catch (error) {
            console.error("Error fetching latest batch price:", error);
        } finally {
            hideLoader();
        }

        setAdjustFormData({
            date: new Date().toISOString().split("T")[0],
            adjustment_type: "add",
            qty: "",
            unit_id: defaultUnit,
            price_unit: defaultPrice,
            total_price: "0.00",
            remarks: "",
        });
        setShowAdjustModal(true);
    };

    const handleAdjustFormChange = (field, value) => {
        setAdjustFormData((prev) => {
            const updated = { ...prev, [field]: value };
            if (field === "qty" || field === "price_unit") {
                const q = parseFloat(field === "qty" ? value : updated.qty) || 0;
                const p = parseFloat(field === "price_unit" ? value : updated.price_unit) || 0;
                updated.total_price = (q * p).toFixed(2);
            } else if (field === "total_price") {
                const t = parseFloat(value) || 0;
                const q = parseFloat(updated.qty) || 0;
                if (q > 0) {
                    updated.price_unit = (t / q).toFixed(2);
                }
            }
            return updated;
        });
    };

    const handleAdjustSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const qtyNum = parseFloat(adjustFormData.qty);
        if (!qtyNum || isNaN(qtyNum) || qtyNum <= 0) {
            toast.error("Please enter a valid quantity greater than 0");
            return;
        }
        if (!adjustFormData.date) {
            toast.error("Please select a date for the adjustment");
            return;
        }

        const currentStock = parseFloat(adjustRawMaterial?.remaining_stock || 0);
        if (adjustFormData.adjustment_type === "deduct" && qtyNum > currentStock) {
            toast.error(`Cannot deduct ${qtyNum}. Only ${currentStock.toFixed(3)} available in stock.`);
            return;
        }

        showLoader();
        try {
            const payload = {
                raw_mat_id: adjustRawMaterial?.id,
                adjustment_type: adjustFormData.adjustment_type,
                date: adjustFormData.date,
                qty: qtyNum,
                unit_id: adjustFormData.unit_id || "",
                price_unit: parseFloat(adjustFormData.price_unit || 0),
                total_price: parseFloat(adjustFormData.total_price || 0),
                remarks: adjustFormData.remarks || `Stock Adjustment (${adjustFormData.adjustment_type === "add" ? "Add Batch" : "Deduct"}) - ${adjustRawMaterial?.title}`,
                shop_id: shopItem?.id,
                user_id: UserItem?.user_id || "0",
            };
            const response = await adjustRawMaterialStock(payload);
            if (response.data && response.data.status === "success") {
                toast.success(response.data.message || "Stock adjusted successfully");
                setShowAdjustModal(false);
                setAdjustRawMaterial(null);
                fetchRawmaterials(currentPage, searchText, activeTab);
            } else {
                toast.error(response.data.message || "Failed to adjust stock");
            }
        } catch (error) {
            console.error("Error adjusting stock:", error);
            toast.error(error.response?.data?.message || "Failed to adjust stock");
        } finally {
            hideLoader();
        }
    };

    useEffect(() => {
        const isPkg = pathname === "/packaging_materials" || search.includes("type=1") || search.includes("tab=pkg") || search.includes("pkg");
        const targetTab = isPkg ? "1" : "raw";
        const targetKey = isPkg ? "packaging_materials" : "raw_materials";
        const targetLimit = getStoredEntriesPerPage(targetKey, 10);
        setActiveTab(targetTab);
        setCurrentPage(1);
        setEntriesPerPage(targetLimit);
        fetchRawmaterials(1, "", targetTab, targetLimit);
        fetchUnitsList();
    }, [pathname, search]);

    const fetchUnitsList = async () => {
        try {
            const response = await getUnits();
            if (response.data && response.data.data) {
                setUnitsList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching units:", error);
        }
    };

    const getUnitName = (unitId) => {
        if (!unitId) return "";
        const found = unitsList.find(u => String(u.id) === String(unitId));
        if (found) return found.title;
        if (String(unitId) === "1") return "kg";
        if (String(unitId) === "2") return "gram";
        if (String(unitId).toLowerCase() === "li") return "li";
        return unitId;
    };

    const handledeletemodel = (ID) => {
        showDeletemodel(true);
        setDeleteID(ID);
    };

    const fetchRawmaterials = async (page = 1, text = searchText, tab = activeTab, limit = entriesPerPage) => {
        showLoader();
        try {
            const response = await getRawMaterials({
                shop_id: shopItem?.id,
                page,
                search: text,
                type: tab,
                limit: limit,
                page_size: limit
            });
            if (response.data && response.data.data) {
                setRawmaterials(response.data.data);
                setTotalPages(response.data.pagination?.total_pages || 1);
            }
        } catch (error) {
            console.error("Error fetching raw materials:", error);
            toast.error("Failed to fetch raw materials");
        } finally {
            hideLoader();
        }
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setCurrentPage(1);
        fetchRawmaterials(1, searchText, tab, entriesPerPage);
    };

    const openAddModal = () => {
        setAddOrEdit(true);
        setSelectedRaw(null);
        console.log('clicked')
        setShowEditModal(true);
    };

    const openEditModal = (raw) => {
        setSelectedRaw(raw);
        setAddOrEdit(false);
        console.log('clicked  222')

        setShowEditModal(true);
    };

    const handleDelete = async () => {
        if (!deleteID) {
            toast.error("No raw material selected to delete");
            return;
        }

        try {
            await deleteRawMaterials(deleteID);
            showDeletemodel(false);
            toast.success("Raw material deleted");
            fetchRawmaterials(currentPage, searchText, activeTab);
        } catch (error) {
            console.error("Error deleting raw material:", error);
            toast.error("Error deleting raw material");
        }
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        fetchRawmaterials(pageNumber, searchText, activeTab, entriesPerPage);
    };

    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }

        const delayDebounceFn = setTimeout(() => {
            setSearchText(searchInput);
            fetchRawmaterials(1, searchInput, activeTab, entriesPerPage);
            setCurrentPage(1);
        }, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [searchInput]);

    const activateRawMaterial = async (value) => {
        showLoader();
        try {
            const payload = {
                ...value,
                status: "active",
            };
            await updateRawMaterials(value?.id, payload);
            fetchRawmaterials(currentPage, searchText, activeTab);
            toast.success("Raw material activated");
        } catch (err) {
            console.error(err);
            toast.error(err.message);
        } finally {
            hideLoader();
        }
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                <NaviGate />
                <div className="mb-0 d-flex justify-content-between align-items-center">
                    <h6
                        className="mb-0 text-uppercase"
                        style={{ fontFamily: "poppins" }}
                    >
                        {activeTab === "1" ? "Packaging Materials List" : "Raw Materials List"}
                    </h6>
                    {!readonly && (
                        <div className="d-flex gap-2">
                            <button
                                type="button"
                                onClick={() => navigate("/purchase")}
                                className="btn btn-success mb-0"
                                style={{ fontFamily: "poppins" }}
                            >
                                RM Purchase
                            </button>
                            <button
                                type="button"
                                onClick={() => openAddModal()}
                                className="btn btn-primary mb-0"
                                style={{ fontFamily: "poppins" }}
                            >
                                {activeTab === "1" ? "Add Packaging Material" : "Add Raw Material"}
                            </button>
                        </div>
                    )}
                </div>
                <hr className="mt-1" />

                <div className="card">
                    <div className="card-body">
                        {/* Tabs removed as menu is now separate in sidebar */}

                        <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
                            <div
                                className="d-flex position-relative"
                                style={{ width: "100%" }}
                            >
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Search..."
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                />
                                <img
                                    src="/assets/images/icons/search.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        right: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        height: "18px",
                                        pointerEvents: "none",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                className="table table-striped table-sm table-bordered"
                                style={{ width: "100%", fontFamily: "poppins" }}
                            >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Title</th>
                                        <th>Type</th>
                                        <th>Product Code</th>
                                        <th>Reorder Point</th>
                                        <th>Stocks Available</th>
                                        {/* <th>Status</th> */}
                                        {/* <th>Created By</th> */}
                                        {!readonly && <th>Actions</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rawmaterials.map((raw, index) => (
                                        <tr key={raw.id}>
                                            <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
                                            <td>{raw.title}</td>
                                            <td>{raw.type == "1" ? "Packaging material" : raw.type == "2" ? "Liquid" : "Spices"}</td>
                                            <td>{raw.product_code}</td>
                                            <td>{raw.reorder_point}</td>
                                            <td>{parseFloat(raw.remaining_stock || 0).toFixed(3)} {raw.type == "2" ? "li" : getUnitName(raw.unit_id)}</td>
                                            {/* <td>{raw.status}</td> */}
                                            {/* <td>{raw.created_by}</td> */}
                                            {!readonly && (
                                                <td>
                                                    <>
                                                         <img
                                                             src="/assets/images/icons/edit.png"
                                                             onClick={() => openEditModal(raw)}
                                                             height="16px"
                                                             alt="Edit"
                                                             style={{ cursor: "pointer" }}
                                                             title="Edit"
                                                         />
                                                         &nbsp;&nbsp;&nbsp;
                                                         <img
                                                             src="/assets/images/icons/transfer-switch.png"
                                                             onClick={() => openAdjustModal(raw)}
                                                             height="16px"
                                                             alt="Adjust Stock"
                                                             style={{ cursor: "pointer" }}
                                                             title="Adjust Stock"
                                                         />
                                                         &nbsp;&nbsp;&nbsp;
                                                         <i
                                                             className="bi bi-file-earmark-text text-primary"
                                                             onClick={() => openReportModal(raw)}
                                                             style={{ cursor: "pointer", fontSize: "17px", verticalAlign: "middle" }}
                                                             title="Date-wise Stock Report"
                                                         ></i>
                                                         &nbsp;&nbsp;&nbsp;
                                                         <img
                                                             src="/assets/images/icons/delete.png"
                                                             onClick={() => handledeletemodel(raw.id)}
                                                             height="16px"
                                                             alt="Delete"
                                                             style={{ cursor: "pointer" }}
                                                             title="Delete"
                                                         />
                                                    </>
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                storageKey={activeTab === "1" ? "packaging_materials" : "raw_materials"}
                                onPageChange={handlePageChange}
                                entriesPerPage={entriesPerPage}
                                onEntriesPerPageChange={(val) => {
                                    const currentKey = activeTab === "1" ? "packaging_materials" : "raw_materials";
                                    setStoredEntriesPerPage(currentKey, val);
                                    setEntriesPerPage(val);
                                    setCurrentPage(1);
                                    fetchRawmaterials(1, searchText, activeTab, val);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {deletemodel && (
                <Deletemodel
                    setShowModal={showDeletemodel}
                    handleDelete={handleDelete}
                />
            )}

            {/* {showEditModal && ( */}
            <EditRawMaterials
                showModal={showEditModal}
                // setShowModal={() => setShowEditModal(false)}
                setShowModal={() => {
                    setShowEditModal(false);
                    setSelectedRaw(null);
                }}
                fetchRawmaterials={() => fetchRawmaterials(currentPage, searchText, activeTab)}
                selectedRawmaterial={selectedRaw}
                AddorEdit={addOrEdit}
                defaultType={activeTab === "1" ? "1" : "0"}
            />

            {showAdjustModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "550px" }}>
                        <div className="modal-content border-0 rounded-3 shadow">
                            <div className="modal-header px-4 py-3 bg-light d-flex justify-content-between align-items-center">
                                <div>
                                    <h5 className="modal-title font-bold text-dark mb-0" style={{ fontFamily: "poppins" }}>
                                        <i className="bi bi-sliders text-primary me-2"></i>
                                        Stock Adjustment: <span className="text-primary">{adjustRawMaterial?.title}</span>
                                    </h5>
                                    <small className="text-muted">
                                        Code: {adjustRawMaterial?.product_code || "N/A"} | Type: {adjustRawMaterial?.type == "1" ? "Packaging material" : adjustRawMaterial?.type == "2" ? "Liquid" : "Spices"} | Current Stock: <strong>{parseFloat(adjustRawMaterial?.remaining_stock || 0).toFixed(2)}</strong>
                                    </small>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() => setShowAdjustModal(false)}
                                ></button>
                            </div>
                            <form onSubmit={handleAdjustSubmit}>
                                <div className="modal-body p-4" style={{ fontFamily: "poppins" }}>
                                    {/* Action Type */}
                                    <div className="mb-3">
                                        <label className="form-label font-semibold text-secondary">Adjustment Action <span className="text-danger">*</span></label>
                                        <div className="d-flex gap-4">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="rawAdjustAction"
                                                    id="rawActionAdd"
                                                    value="add"
                                                    checked={adjustFormData.adjustment_type === "add"}
                                                    onChange={(e) => handleAdjustFormChange("adjustment_type", e.target.value)}
                                                />
                                                <label className="form-check-label" htmlFor="rawActionAdd">
                                                    Add Stock (UP)
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="rawAdjustAction"
                                                    id="rawActionDeduct"
                                                    value="deduct"
                                                    checked={adjustFormData.adjustment_type === "deduct"}
                                                    onChange={(e) => handleAdjustFormChange("adjustment_type", e.target.value)}
                                                />
                                                <label className="form-check-label" htmlFor="rawActionDeduct">
                                                    Deduct Stock (DOWN)
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Date */}
                                    <div className="mb-3">
                                        <label className="form-label font-semibold text-secondary">Adjustment Date <span className="text-danger">*</span></label>
                                        <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            value={adjustFormData.date}
                                            onChange={(e) => handleAdjustFormChange("date", e.target.value)}
                                            required
                                        />
                                    </div>

                                    {/* Quantity and Unit */}
                                    <div className="row g-2 mb-3">
                                        <div className="col-md-7">
                                            <label className="form-label font-semibold text-secondary">Quantity to Adjust <span className="text-danger">*</span></label>
                                            <input
                                                type="number"
                                                step="any"
                                                min="0.001"
                                                className="form-control form-control-sm"
                                                placeholder="Enter quantity"
                                                value={adjustFormData.qty}
                                                onChange={(e) => handleAdjustFormChange("qty", e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-5">
                                            <label className="form-label font-semibold text-secondary">Unit</label>
                                            <select
                                                className="form-select form-select-sm"
                                                value={adjustFormData.unit_id}
                                                onChange={(e) => handleAdjustFormChange("unit_id", e.target.value)}
                                            >
                                                <option value="">Select Unit</option>
                                                {(adjustRawMaterial?.type === "2" ? unitsList.filter(u => {
                                                    const title = (u.title || "").toLowerCase();
                                                    return title === "li" || title === "litre" || title === "litres" || title === "liter" || title === "liters";
                                                }) : adjustRawMaterial?.type === "1" ? [
                                                    unitsList.find(u => u.title?.toLowerCase() === "pcs") || { id: "pcs", title: "pcs" },
                                                    unitsList.find(u => u.title?.toLowerCase() === "kg") || { id: "kg", title: "kg" }
                                                ].filter(Boolean) : adjustRawMaterial?.type === "0" ? unitsList.filter(u => {
                                                    const title = (u.title || "").toLowerCase();
                                                    return title === "kg" || title === "kilogram" || title === "kilograms" || title === "g" || title === "gm" || title === "gram" || title === "grams";
                                                }) : unitsList).map((unit) => (
                                                    <option key={unit.id} value={unit.id}>
                                                        {unit.title}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Price and Total */}
                                    <div className="row g-2 mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label font-semibold text-secondary">Unit Price (INR)</label>
                                            <input
                                                type="number"
                                                step="any"
                                                min="0"
                                                className="form-control form-control-sm"
                                                placeholder="Unit price"
                                                value={adjustFormData.price_unit}
                                                onChange={(e) => handleAdjustFormChange("price_unit", e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label font-semibold text-secondary">Total Value (INR)</label>
                                            <input
                                                type="number"
                                                step="any"
                                                min="0"
                                                className="form-control form-control-sm"
                                                placeholder="Total price"
                                                value={adjustFormData.total_price}
                                                onChange={(e) => handleAdjustFormChange("total_price", e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    {/* Remarks */}
                                    <div className="mb-2">
                                        <label className="form-label font-semibold text-secondary">Remarks / Reason</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Optional remarks"
                                            value={adjustFormData.remarks}
                                            onChange={(e) => handleAdjustFormChange("remarks", e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="modal-footer border-t px-4 py-2 bg-light d-flex justify-content-end gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        onClick={() => setShowAdjustModal(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-sm px-3"
                                    >
                                        Save Adjustment
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
            {/* Date-Wise Stock Report Modal */}
            {showReportModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog modal-xl modal-dialog-centered" style={{ maxWidth: "95%", width: "1250px" }}>
                        <div className="modal-content border-0 rounded-3 shadow">
                            <div className="modal-header px-4 py-3 bg-light d-flex justify-content-between align-items-center">
                                <div>
                                    <h5 className="modal-title font-bold text-dark mb-0" style={{ fontFamily: "poppins" }}>
                                        <i className="bi bi-journal-text text-primary me-2"></i>
                                        Date-Wise Stock Report: <span className="text-primary">{reportRawMaterial?.title}</span>
                                    </h5>
                                    <small className="text-muted">
                                        Code: {reportRawMaterial?.product_code || "N/A"} | Type: {reportRawMaterial?.type == "1" ? "Packaging material" : reportRawMaterial?.type == "2" ? "Liquid" : "Spices"}
                                    </small>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() => setShowReportModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body p-4" style={{ fontFamily: "poppins", maxHeight: "75vh", overflowY: "auto" }}>
                                
                                {(() => {
                                    const convertTxQtyToBaseUnit = (tx) => {
                                        const rawQty = parseFloat(tx.qty || 0);
                                        if (!rawQty || isNaN(rawQty)) return 0;

                                        const baseUnit = (reportRawMaterial?.type == "2" ? "li" : getUnitName(reportRawMaterial?.unit_id) || "kg").toLowerCase().trim();
                                        const txUnit = (getUnitName(tx.unit_id) || tx.unit_id || baseUnit).toString().toLowerCase().trim();

                                        if (txUnit === baseUnit) {
                                            return rawQty;
                                        }

                                        const pcsPerKg = parseFloat(reportRawMaterial?.pcs_per_kg || 0);

                                        // If Base is KG and Tx is Grams
                                        if ((baseUnit === "kg" || baseUnit === "kilogram" || baseUnit === "1") && (txUnit === "gram" || txUnit === "grams" || txUnit === "g" || txUnit === "2")) {
                                            return rawQty / 1000;
                                        }

                                        // If Base is Grams and Tx is KG
                                        if ((baseUnit === "gram" || baseUnit === "grams" || baseUnit === "g" || baseUnit === "2") && (txUnit === "kg" || txUnit === "kilogram" || txUnit === "1")) {
                                            return rawQty * 1000;
                                        }

                                        // If Base is KG and Tx is Pieces (pcs)
                                        if ((baseUnit === "kg" || baseUnit === "kilogram" || baseUnit === "1") && (txUnit === "pcs" || txUnit === "piece" || txUnit === "pieces" || txUnit === "pkt")) {
                                            if (pcsPerKg > 0) {
                                                return rawQty / pcsPerKg;
                                            }
                                            const priceUnit = parseFloat(tx.price_unit || 0);
                                            const basePrice = parseFloat(reportRawMaterial?.price_unit || reportRawMaterial?.latest_price_unit || reportRawMaterial?.cost_price || 0);
                                            if (priceUnit > 0 && basePrice > 0) {
                                                const calculatedPcsPerKg = basePrice / priceUnit;
                                                if (calculatedPcsPerKg > 0) {
                                                    return rawQty / calculatedPcsPerKg;
                                                }
                                            }
                                        }

                                        // If Base is Pieces and Tx is KG
                                        if ((baseUnit === "pcs" || baseUnit === "piece" || baseUnit === "pieces") && (txUnit === "kg" || txUnit === "kilogram" || txUnit === "1")) {
                                            if (pcsPerKg > 0) {
                                                return rawQty * pcsPerKg;
                                            }
                                        }

                                        return rawQty;
                                    };

                                    const totalAdded = allReportTransactions
                                        .filter(t => String(t.add_taken) === "1")
                                        .reduce((acc, t) => acc + convertTxQtyToBaseUnit(t), 0);

                                    const totalTaken = allReportTransactions
                                        .filter(t => String(t.add_taken) === "0")
                                        .reduce((acc, t) => acc + convertTxQtyToBaseUnit(t), 0);

                                    const totalTakenPcs = allReportTransactions
                                        .filter(t => String(t.add_taken) === "0" && (getUnitName(t.unit_id) || t.unit_id || "").toString().toLowerCase().includes("pc"))
                                        .reduce((acc, t) => acc + (parseFloat(t.qty) || 0), 0);

                                    const displayedTransactions = allReportTransactions.filter(item => {
                                        if (reportFilter === "1") return String(item.add_taken) === "1";
                                        if (reportFilter === "0") return String(item.add_taken) === "0";
                                        return true;
                                    });

                                    const unitStr = reportRawMaterial?.type == "2" ? "li" : getUnitName(reportRawMaterial?.unit_id);

                                    return (
                                        <>
                                            {/* Summary Cards */}
                                            <div className="row g-3 mb-4">
                                                <div className="col-md-4">
                                                    <div className="card h-100 border-0 shadow-sm bg-success bg-opacity-10 rounded-3 p-3 text-center d-flex flex-column justify-content-center">
                                                        <span className="text-uppercase text-muted fw-bold text-xs" style={{ fontSize: "11px" }}>Total Stock Added</span>
                                                        <h4 className="text-success fw-bold mb-0 mt-1 d-flex align-items-baseline justify-content-center gap-1">
                                                            <span>+ {totalAdded.toFixed(3)}</span>
                                                            <small style={{ fontSize: "14px" }}>{unitStr}</small>
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card h-100 border-0 shadow-sm bg-danger bg-opacity-10 rounded-3 p-3 text-center d-flex flex-column justify-content-center">
                                                        <span className="text-uppercase text-muted fw-bold text-xs" style={{ fontSize: "11px" }}>Total Stock Taken</span>
                                                        <h4 className="text-danger fw-bold mb-0 mt-1 d-flex align-items-baseline justify-content-center gap-1">
                                                            <span>- {totalTaken.toFixed(3)}</span>
                                                            <small style={{ fontSize: "14px" }}>{unitStr}</small>
                                                            {/* {totalTakenPcs > 0 && unitStr.toLowerCase() !== "pcs" && (
                                                                <small className="text-danger fw-semibold" style={{ fontSize: "13px" }}>
                                                                    ({totalTakenPcs.toFixed(0)} pcs)
                                                                </small>
                                                            )} */}
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card h-100 border-0 shadow-sm bg-primary bg-opacity-10 rounded-3 p-3 text-center d-flex flex-column justify-content-center">
                                                        <span className="text-uppercase text-muted fw-bold text-xs" style={{ fontSize: "11px" }}>Current Available Stock</span>
                                                        <h4 className="text-primary fw-bold mb-0 mt-1 d-flex align-items-baseline justify-content-center gap-1">
                                                            <span>{parseFloat(reportRawMaterial?.remaining_stock || 0).toFixed(3)}</span>
                                                            <small style={{ fontSize: "14px" }}>{unitStr}</small>
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Filter Tabs & Print Button */}
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="d-flex gap-2">
                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm ${reportFilter === "" ? "btn-primary shadow-none" : "btn-outline-primary shadow-none"}`}
                                                        style={{ borderRadius: "6px", boxShadow: "none", outline: "none" }}
                                                        onClick={() => setReportFilter("")}
                                                    >
                                                        All Transactions
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm ${reportFilter === "1" ? "btn-success shadow-none text-white" : "btn-outline-success shadow-none"}`}
                                                        style={{ borderRadius: "6px", boxShadow: "none", outline: "none" }}
                                                        onClick={() => setReportFilter("1")}
                                                    >
                                                        <i className="bi bi-arrow-down-left-circle me-1"></i> Stock Added (In)
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm ${reportFilter === "0" ? "btn-danger shadow-none text-white" : "btn-outline-danger shadow-none"}`}
                                                        style={{ borderRadius: "6px", boxShadow: "none", outline: "none" }}
                                                        onClick={() => setReportFilter("0")}
                                                    >
                                                        <i className="bi bi-arrow-up-right-circle me-1"></i> Stock Taken (Out)
                                                    </button>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-secondary shadow-none"
                                                    style={{ borderRadius: "6px", boxShadow: "none" }}
                                                    onClick={handlePrintReport}
                                                >
                                                    <i className="bi bi-printer me-1"></i> Print / Export
                                                </button>
                                            </div>

                                            {/* Printable Content Area */}
                                            <div ref={reportPrintRef}>
                                                {reportLoading ? (
                                                    <div className="text-center py-5">
                                                        <div className="spinner-border text-primary" role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                        <p className="text-muted mt-2">Loading transactions...</p>
                                                    </div>
                                                ) : displayedTransactions.length === 0 ? (
                                                    <div className="alert alert-info text-center py-4 mb-0">
                                                        <i className="bi bi-info-circle fs-4 d-block mb-2"></i>
                                                        No transactions found for this filter view.
                                                    </div>
                                                ) : (
                                                    <div className="table-responsive">
                                                        <table className="table table-striped table-bordered table-sm align-middle text-xs mb-0">
                                                            <thead className="table-light">
                                                                <tr>
                                                                    <th>S.No</th>
                                                                    <th>Date & Time</th>
                                                                    <th>Type</th>
                                                                    <th>Quantity</th>
                                                                    <th>Unit Price</th>
                                                                    <th>Total Price</th>
                                                                    <th>Supplier / Remarks</th>
                                                                    <th>Remaining Balance</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {displayedTransactions.map((item, idx) => {
                                                                    const isAdded = String(item.add_taken) === "1";
                                                                    const formattedDate = item.date_time
                                                                        ? new Date(item.date_time).toLocaleString("en-GB", {
                                                                            day: "2-digit",
                                                                            month: "short",
                                                                            year: "numeric",
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                            hour12: true
                                                                        })
                                                                        : "-";
                                                                    const rowUnitStr = reportRawMaterial?.type == "2" ? "li" : getUnitName(item.unit_id || reportRawMaterial?.unit_id);
                                                                    return (
                                                                        <tr key={item.id || idx}>
                                                                            <td>{idx + 1}</td>
                                                                            <td className="fw-semibold">{formattedDate}</td>
                                                                            <td>
                                                                                {isAdded ? (
                                                                                    <span className="badge bg-success text-white px-2 py-1">
                                                                                        <i className="bi bi-plus-circle me-1"></i> Added
                                                                                    </span>
                                                                                ) : (
                                                                                    <span className="badge bg-danger text-white px-2 py-1">
                                                                                        <i className="bi bi-dash-circle me-1"></i> Taken
                                                                                    </span>
                                                                                )}
                                                                            </td>
                                                                            <td className={`fw-bold ${isAdded ? "text-success" : "text-danger"}`}>
                                                                                {isAdded ? `+ ${parseFloat(item.qty || 0).toFixed(3)}` : `- ${parseFloat(item.qty || 0).toFixed(3)}`} {rowUnitStr}
                                                                            </td>
                                                                            <td>₹{parseFloat(item.price_unit || 0).toFixed(2)}</td>
                                                                            <td>₹{parseFloat(item.price || 0).toFixed(2)}</td>
                                                                            <td style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                                                                                {item.supplier_name ? (
                                                                                    <span><strong>Supplier:</strong> {item.supplier_name}</span>
                                                                                ) : item.remarks ? (
                                                                                    <span>{item.remarks}</span>
                                                                                ) : (
                                                                                    <span className="text-muted">-</span>
                                                                                )}
                                                                            </td>
                                                                            <td className="fw-semibold">
                                                                                {item.remaining != null ? `${parseFloat(item.remaining).toFixed(3)} ${rowUnitStr}` : "-"}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    );
                                })()}
                            </div>
                            <div className="modal-footer border-t px-4 py-2 bg-light text-end">
                                <button
                                    type="button"
                                    className="btn btn-secondary btn-sm"
                                    onClick={() => setShowReportModal(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RawMaterials;
